import {inject} from "@angular/core";
import {OrdnerService} from '../services/apiservices/ordner.service';
import {switchMap} from "rxjs";
import {map} from "rxjs/operators";
import {rechteResolver} from "./rechte.resolver";

export const ordnerResolver = () => {
    // First load postfachkonto, and only ever if that is successful, load the ordner data
    let ordnerService = inject(OrdnerService);

    return rechteResolver()
        .pipe(
            switchMap(benutzerRechte =>
                ordnerService.getOrdner()
                    .pipe(
                        map(ordnerList => ({
                            benutzerRechte: benutzerRechte,
                            ordnerList: ordnerList
                        }))
                    )
            )
        );
}
